import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const getNotifications = async () => {
  try {
    const token = getToken();
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}notification/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Failed to fetch Notifications data:", error);
    throw error;
  }
};

const getNotificationById = async (id) => {
  try {
    const token = getToken();
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}notification/?id=${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Failed to fetch Partiular Notification data:", error);
    throw error;
  }
};

const markNotificationsAsRead = async () => {
  try {
    const token = getToken();
    const response = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}notification/markread/`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Failed to fetch Notifications data:", error);
    throw error;
  }
};

export { getNotifications, getNotificationById, markNotificationsAsRead };
